const getStackedTravelersLabel = count =>
  count > 0 ? I18n.t('components.flight.exchange.previous_item.travelers', { count }) : null;

export default getStackedTravelersLabel;
